import React, { createContext, useContext } from 'react';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

const ItineraryContext = createContext<any>({});
const ItineraryPositionContext = createContext<number>(0);

export const useItinerary = () => useContext(ItineraryContext);

export const useFeePrice = (feeTypeId) => {
  const { fees } = useItinerary();
  return fees.find(({ type }) => type.id === feeTypeId);
};

const countDays = ({ from, to }) => {
  try {
    const diff = differenceInCalendarDays(to, from);
    return diff || 0;
  } catch {
    return 0;
  }
};

export const useDestinationInfo = () => {
  const { legs } = useItinerary();

  const arrivalSegments = legs[0]?.segments || [];
  const lastArrivalSegment =
    arrivalSegments[(arrivalSegments.length || 0) - 1] || null;
  const arrivalDate = new Date(lastArrivalSegment?.arrivalDate);
  const destinationName = lastArrivalSegment?.destination?.cityName || null;
  const departureDate = new Date(legs[1]?.segments[0]?.departureDate);
  const amountNights = countDays({ from: arrivalDate, to: departureDate });
  return {
    amountNights,
    destinationName,
    isRoundtrip: legs.length === 2,
  };
};

export const useItineraryPosition = () => useContext(ItineraryPositionContext);

const ItineraryProvider = ({ children, itinerary, position = 0 }) => {
  return (
    <ItineraryContext.Provider value={itinerary}>
      <ItineraryPositionContext.Provider value={position}>
        {children}
      </ItineraryPositionContext.Provider>
    </ItineraryContext.Provider>
  );
};

export default ItineraryProvider;
